import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import * as echarts from 'echarts';
import * as dmaData from '../../../assets/data/dma-shapes.json';
import * as dmaProps from '../../../assets/data/dma-properties.json';


@Injectable({
    providedIn: 'root'
})
 export class MapService {
     
    public constructor(private httpClient: HttpClient) {

    }

    public getJson(type) {
        var data;
       if (type === 'zipcodes')
        {
            data = this.httpClient.get('../../assets/data/zipcode-shapes.json');
        }
        else if (type === 'census')
        {
            data = this.httpClient.get('../../assets/data/census-shapes.json');
        }
        else
        {
            data = dmaData;
        }

        echarts.registerMap(type, data.default); 
       
        return data.default
    }

    public getProperties(type) {
        var props;
       if (type === 'zipcodes')
        {
            props = this.httpClient.get('../../assets/data/zipcode-shapes.json');
        }
        else if (type === 'census')
        {
            props = this.httpClient.get('../../assets/data/census-shapes.json');
        }
        else
        {
            props = dmaProps
        }

        // console.log(props.default)
        return props.default
    }


 }